/**
 * Resolves the destination a user should land on immediately after registering,
 * based on the role they chose on the Register page ("I want to join as").
 *
 * This is shared between RegisterPage (which records the choice) and the
 * /register route guard (which performs the redirect). Routing from a single
 * source — the guard reading `pendingRole` from the auth store — avoids a race
 * where RegisterPage's programmatic `navigate()` and the guard's
 * `<Navigate to="/feed">` both fire on the `login()` state change and the guard
 * wins, dropping the chosen role.
 *
 *  - Supporter / Ni-kshay Mitra roles → the supporter registration form
 *    (POST /supporters/register), pre-selected with the chosen type.
 *  - Account roles (CITIZEN) → /complete-profile, where CompleteProfilePage
 *    auto-applies the role (no re-select) via pendingRole. Doctor / Health
 *    Worker personas were retired and are no longer selectable at registration.
 *  - No role / unknown → /complete-profile (manual selection grid).
 */
export const SUPPORTER_ROLE_IDS = [
  'NIKSHAY_MITRA_INDIVIDUAL',
  'NIKSHAY_MITRA_NGO',
  'NIKSHAY_MITRA_CORPORATE',
  'NUTRITION_SPONSOR',
  'VOLUNTEER',
]

export function isSupporterRole(role: string | null | undefined): boolean {
  return !!role && SUPPORTER_ROLE_IDS.includes(role)
}

export function postRegisterTarget(role: string | null | undefined): string {
  if (role && isSupporterRole(role)) {
    return `/support-a-patient?type=${encodeURIComponent(role)}&register=1`
  }
  return '/complete-profile'
}